var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonIconDarkMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 11.724a8.25 8.25 0 01-5.412 7 8.25 8.25 0 01-8.636-1.926 8.25 8.25 0 01-1.926-8.636 8.25 8.25 0 017-5.412 6.416 6.416 0 008.974 8.974z",
    stroke: "#fff",
    strokeWidth: 1.833,
    strokeLinejoin: "round"
  })));
}
export default SvgMoonIconDarkMode;